export default __webpack_public_path__ + "static/4-535db8872a87f7eaff19371d8ffa027d.jpeg";